<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{!serviceId ? 'Add' : 'Update'}} Blacklist IP</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="servicerequestform" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
            style="margin-bottom: 20px;align-items: baseline;">
            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-label>IP Address</mat-label>
              <input matInput placeholder="IP Address" formControlName="ipAddress">
              <mat-error
                *ngIf="servicerequestform.controls['ipAddress'].touched && servicerequestform.controls['ipAddress'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
          </fxLayout>
          </div>
            

            <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
              <button mat-button type="button" class="sub-button" (click)="submit()"><span>{{!serviceId ? 'Add' : 'Update'}}</span></button>
            </div>
  
           
          </form>
    </div>
  </div>
